import { Heart } from "lucide-react";
import { useFavorites } from "@/hooks/useFavorites";
import { useApp } from "@/contexts/AppContext";
import { useNavigate } from "react-router-dom";

export default function FavoriteButton({ listingId, className = "" }: { listingId: string; className?: string }) {
  const { user } = useApp();
  const { favorites, toggleFavorite } = useFavorites();
  const navigate = useNavigate();
  const isFav = favorites.includes(listingId);

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { navigate("/login"); return; }
    toggleFavorite(listingId);
  }

  return (
    <button
      onClick={handleClick}
      className={`p-1.5 rounded-full transition-colors ${isFav ? "text-red-500 hover:text-red-600" : "text-muted-foreground hover:text-red-400"} ${className}`}
      aria-label={isFav ? "Remover dos favoritos" : "Adicionar aos favoritos"}
    >
      <Heart className={`h-4 w-4 ${isFav ? "fill-current" : ""}`} />
    </button>
  );
}
